import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
import React from 'react'
import { FeaturesType } from 'src/types'

import CartSubContent from '../Cart/CartSubContent'

interface CheckDataListProps {
  features: FeaturesType[]
  classnames?: string
  isBold?: boolean
  isFullWidth?: boolean
  forField?: string
}

/**
 * Primary UI component for user interaction
 */
export const CheckDataList: React.FC<CheckDataListProps> = ({
  features = [],
  classnames,
  isBold = false,
  isFullWidth = false,
  forField = '',
}) => {
  return (
    <div className={cn('grid ', classnames, isFullWidth ? '' : 'md:grid-cols-2')}>
      {features.map((feature: FeaturesType, index: number) => {
        return (
          <CartSubContent
            key={index}
            className={cn(
              {
                'opacity-50': !feature.isChecked,
              },
              'w-full h-[30px] font-primary font-medium leading-[19px] text-darkgray flex flex-row',
              forField === 'OPEN_TO_INVESTMENT' ? '' : 'mt-[4px]',
            )}
          >
            {feature.isChecked && (
              <IonIcon
                name="checkmark-circle"
                style={{ width: '20px', height: '20px', marginRight: '12px', color: '#011D58' }}
              />
            )}
            {!feature.isChecked && (
              <IonIcon
                name="close-circle"
                style={{ width: '20px', height: '20px', marginRight: '12px', color: '#011D58' }}
              />
            )}
            <span
              className={`flex-1 ${isBold ? 'font-secondary font-semibold text-[0.875rem] text-darkgray leading-[21px] line-height-[1px]' : ''}`}
            >
              {feature.name}
            </span>
          </CartSubContent>
        )
      })}
    </div>
  )
}
